/** Subcontractor insurance that has lapsed or is about to, for the "Coming up"
 *  list. The cover routes are workspace-admin only on the server, so a 403 is
 *  the normal answer for everyone else and any failure just means no rows.
 *  Refetches when the date changes so a policy entering the window appears on
 *  a dashboard left open overnight. */

import { useEffect, useMemo, useState } from 'react';
import type { ExpiringSubcontractorCover } from '../subcontractors/subcontractorCover';
import { useBackgroundRead } from '../../hooks/useBackgroundRead';
import { expiringSubcontractorCoverRead, localDayKey } from './homeComingUpReads';

const DAY_CHECK_MS = 5 * 60_000;
const NONE: readonly ExpiringSubcontractorCover[] = [];

export function useExpiringSubcontractorCover(workspaceId: string | undefined): readonly ExpiringSubcontractorCover[] {
  const [dayKey, setDayKey] = useState(localDayKey);

  useEffect(() => {
    const id = window.setInterval(() => setDayKey(localDayKey()), DAY_CHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const read = useMemo(() => (workspaceId ? expiringSubcontractorCoverRead(workspaceId) : null), [workspaceId]);
  return useBackgroundRead(workspaceId, read, { refreshKey: dayKey }) ?? NONE;
}
